/** Khoze chat course-picker options — shared by the desktop settings card and
 *  the mobile chat-header picker so both surfaces can never diverge. */

export interface CourseOption { value: string; label: string }

/** "General chats" first (empty value), then the user's courses in order. */
export function courseOptions(courses: Array<{ id: string; title: string }>, generalLabel: string): CourseOption[] {
  return [
    { value: "", label: generalLabel },
    ...courses.map((course) => ({ value: course.id, label: course.title }))
  ];
}
